module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/ednote7"
    }
  }, [_vm._v("EDITOR’S NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/carrillo817"
    }
  }, [_vm._v("H. G. Carrillo, "), _c('i', [_vm._v("Splaining Yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/steger1822"
    }
  }, [_vm._v("Aleš Šteger, "), _c('i', [_vm._v("Three Berlin Essays")]), _vm._v(" (translated from Slovenian by Brian Henry)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/hodgen2336"
    }
  }, [_vm._v("Christie Hodgen, "), _c('i', [_vm._v("Customer Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/straub3744",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Straub, "), _c('i', [_vm._v("The Collected Short Stories of Freddie Prothero, Introduction by Törless Magnussen, PhD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/vandenberg4562",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laura van den Berg, "), _c('i', [_vm._v("Havana")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/olsen6377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lance Olsen, "), _c('i', [_vm._v("Dreamlives of Debris")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/parras78102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Parras, "), _c('i', [_vm._v("Song of Magsaysay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/welish103111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marjorie Welish, "), _c('i', [_vm._v("Folding Cythera")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/west112124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul West, "), _c('i', [_vm._v("Omobo")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/baudelaire125145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Baudelaire, "), _c('i', [_vm._v("Poor Belgium: The Argument")]), _vm._v(" (translated from French with an Introduction by Richard Sieburth)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chernoff146150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maxine Chernoff, "), _c('i', [_vm._v("Five Poems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/evenson151160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brian Evenson, "), _c('i', [_vm._v("Cult")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/hemley161176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robin Hemley, "), _c('i', [_vm._v("Celebrating Russian Federation Day with Immanuel Kant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/meidav177189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edie Meidav, "), _c('i', [_vm._v("Dog’s Journey")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/oconnor190214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen O’Connor, "), _c('i', [_vm._v("The Zip")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/conoley215226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gillian Conoley, "), _c('i', [_vm._v("Preparing One’s Consciousness for the Avatar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xue227240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can Xue, "), _c('i', [_vm._v("Coal")]), _vm._v(" (translated from Chinese by Annelise Finegan Wasmoen)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/riker241262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martin Riker, "), _c('i', [_vm._v("Samuel Johnson’s Eternal Return")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/weitzel263280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wil Weitzel, "), _c('i', [_vm._v("The Gujjar at the River")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/pitt281295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew Pitt, "), _c('i', [_vm._v("A Damn Sight")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/sze296301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arthur Sze, "), _c('i', [_vm._v("Water Calligraphy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/blackwell302315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gabriel Blackwell, "), _c('i', [_vm._v("The Invention of an Island")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/carter316328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robyn Carter, "), _c('i', [_vm._v("Aftershock")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/contributors329331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes on Contributors")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5d557a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents56.vue
// module id = 66
// module chunks = 0